import type { Shape } from '../geom';
import { isEntity, type EntityNode, type EntityType, type SceneNode } from '../model';
import { ARC } from './arc';
import { CIRCLE } from './circle';
import { LINE } from './line';
import type { EntityDefinition, FieldSpec } from './types';

type Registry = {
  readonly [K in EntityType]: EntityDefinition<Extract<EntityNode, { type: K }>, Shape>;
};

/** Every entity kind the core understands, keyed by the node's `type`. */
export const ENTITIES: Registry = { line: LINE, circle: CIRCLE, arc: ARC };

export function definitionOf(type: EntityType): EntityDefinition {
  // Keyed by the same discriminant the node carries, so the lookup always matches.
  return ENTITIES[type] as unknown as EntityDefinition;
}

export function fieldsOf(node: SceneNode): readonly FieldSpec[] {
  return isEntity(node) ? ENTITIES[node.type].fields : [];
}

export type { EntityDefinition, Evaluate, FieldSpec, FieldUnit } from './types';
